export default __webpack_public_path__ + "static/media/residing-address-img.7f5ffe4f.png";